// extracted by mini-css-extract-plugin
export var button = "_la-0";
export var donut = "_la-1";
export var donutFill = "_la-3";
export var donutTrack = "_la-2";